import useGlobalStore from "store";
import { useShallow } from "zustand/react/shallow";

const useStore = (properties, slice) => properties?.length ?
	useGlobalStore(
		useShallow((state) => properties.reduce((acc, property) => ({ ...acc, [property]: state[slice][property] }), {}))
	) :
	useGlobalStore(useShallow((state) => state[slice]));

export const useCart = (properties) => useStore(properties, "cart");

export const useCustomer = (
	properties = ["id", "numberOfOrders", "email", "tags", "defaultAddress", "isAuthenticated"]
) => useStore(properties, "customer");

export const useSettings = (properties) => useStore(properties, "settings");

export const useWishlist = (properties) => useStore(properties, "wishlist");

export const useFilters = (properties) => useStore(properties, "filters");

export default useStore;